import React, {memo, useEffect} from 'react';
import styles from './styles.module.scss';
import useHome from "@/app/features/home/slice";
import Switch from "@/app/components/switch";
import {t} from "i18next";
import {s} from "@/app/utils/s";
import MyPadelLocation from "@/app/features/home/components/my_padel_location";
import PreviousPlaces from "@/app/features/home/components/previous_places/widget";
import FillOutProfile from "@/app/features/home/components/fill_out_profile/widget";
import CircularProgressIndicator from "@/app/components/circular_progress_indicator";
import useLocationHooks from "@/app/features/home/components/my_padel_location/slice";

const HomePage = () => {
  const {
    state,
    goToOnboarding,
    changeUnavailable,
    setRadius,
    goToFindPlayers,
    updateLocationOnSever
  } = useHome();
  const {stateLocation, getCoords, onCitySelect} = useLocationHooks();

  useEffect(() => {
    updateLocationOnSever(stateLocation.coords);
  }, [stateLocation.coords]);

  useEffect(() => {
    getCoords();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.home}>
      {state.hasLoading && <div className={styles.loading}>
          <CircularProgressIndicator isGreen/>
      </div>}
      {!state.hasLoading &&
          <>
             <div className={styles.switch}>
                 <Switch value={state.unavailable} onChange={changeUnavailable}
                         title={t(state.unavailable ? s.available : s.unavailable)}
                         titleDesktop={t(state.unavailable ? s.yourStatusAvailable : s.yourStatusUnavailable)}
                         subtitleDesktop={t(state.unavailable ? s.clickToBecomeUnavailable : s.clickToBecomeAvailable)}/>
             </div>
            {state.user && (
              <FillOutProfile
                goToOnboarding={goToOnboarding}
                user={state.user}
              />
            )}
              <div className={styles.wrapperLocationAndPlaces}>
                  <MyPadelLocation setRadius={setRadius} initialValue={state.radius}
                                   goToFindPlayers={goToFindPlayers} getCoords={getCoords} coords={stateLocation.coords}
                                   coordsError={stateLocation.hasError} onCitySelect={onCitySelect} 
                                   selectedCity={stateLocation.selectedCity} isUsingCityCoords={stateLocation.isUsingCityCoords}/>
                  <PreviousPlaces/>
              </div>
          </>
      }
    </div>
  );
};

export default memo(HomePage);
